
import { defineComponent } from 'vue'

// program information
interface ProgramInfo {
  title: string,
  type: string,
  url: string,
  text: string
}

export default defineComponent({
  data () {
    return {
      programs: [
        {
          title: 'altermagnet_SC',
          type: 'Julia, Mathematica',
          url: 'https://github.com/shuntarosumita/altermagnet_SC',
          text: '<a href="https://arxiv.org/abs/2506.22297" target="_blank">2506.22297</a>の研究で用いたプログラム．“Ginzburg-Landau”フォルダ以下はGL自由エネルギーの係数を計算するためのソースコードである．また，FF超伝導を仮定して平均場方程式を解くプログラムは“mean_field”フォルダ以下に，<a href="https://github.com/SpM-lab/SparseIR.jl/tree/main" target="_blank">SparseIR.jl</a>パッケージを用いてRPAのもとでハバード模型の線形化Eliashberg方程式を解くプログラムは“Hubbard”フォルダ以下にある．'
        },
        {
          title: 'asymmetry_autumn_school_2024',
          type: 'Julia',
          url: 'https://github.com/shuntarosumita/asymmetry_autumn_school_2024',
          text: '2024年9月に行われた<a href="https://asymmetry.hiroshima-u.ac.jp/event/1097" target="_blank">アシンメトリ量子若手秋の学校</a>で，講義の副教材として用いたプログラム．ハバード模型を出発点として，平均場理論に基づく磁気秩序変数の計算(mean_field) および RPA・FLEX近似に基づく動的感受率の計算(rpa_flex)を行うためのソースコードである．'
        },
        {
          title: 'antiferro_spin_parity',
          type: 'Python, Julia',
          url: 'https://github.com/shuntarosumita/antiferro_spin_parity',
          text: '<a href="https://arxiv.org/abs/2402.19311" target="_blank">2402.19311</a>の研究で用いたプログラム．“ed”フォルダ以下は<a href="https://github.com/weinbe58/QuSpin/" target="_blank">QuSpin</a>パッケージを用いて厳密対角化を行うためのソースコードである．“irreducibility”フォルダ以下は，ハミルトニアンをZ<sub>2</sub>対称性の固有値ごとにブロック対角化した各セクターの既約性に関連しており(詳細はSupplemental Materialsに記載)，その証明の一環として作成したアルゴリズムをJuliaで実装したものである(スピン1から9/2の系まで対応している)．'
        },
        {
          title: 'kappaET2X_AFM_SC',
          type: 'Julia',
          url: 'https://github.com/shuntarosumita/kappaET2X_AFM_SC',
          text: '<a href="https://arxiv.org/abs/2308.14227" target="_blank">2308.14227</a>の研究で用いたプログラム．有機化合物群κ-(BEDT-TTF)<sub>2</sub><i>X</i>のハバード模型を対象として，FLEX近似に基づく感受率の計算を行い，それを線形化Eliashberg方程式に取り込んで固有値と秩序変数を求めている．FFLO超伝導を見たかったので，有限の重心運動量を考慮したEliashberg方程式を用いた．松原周波数のメッシュを削減するため<a href="https://github.com/SpM-lab/SparseIR.jl/tree/main" target="_blank">SparseIR.jl</a>を採用している．'
        },
        {
          title: 'supercurrent_TSC',
          type: 'Julia, Mathematica',
          url: 'https://github.com/shuntarosumita/supercurrent_TSC',
          text: '<a href="https://arxiv.org/abs/2110.06959" target="_blank">2110.06959</a>の一部，および<a href="https://arxiv.org/abs/2201.07397" target="_blank">2201.07397</a>の研究で用いたプログラム．超伝導電流を流した状態のエネルギー固有値やChern数・Berry位相の計算など．'
        },
        {
          title: 'TSC_junction',
          type: 'Julia',
          url: 'https://github.com/shuntarosumita/TSC_junction',
          text: '<a href="https://arxiv.org/abs/2109.02918" target="_blank">2109.02918</a>の研究で用いたプログラム．SNS接合系のエネルギー固有値を求める問題を「Corner-modified banded block-Toeplitz行列」と呼ばれる行列の対角化にうまいこと帰着させている．詳しくは論文を参照．'
        },
        {
          title: 'multipole_SC',
          type: 'Mathematica',
          url: 'https://github.com/shuntarosumita/multipole_SC',
          text: '<a href="https://arxiv.org/abs/2004.08086" target="_blank">2004.08086</a>の研究の一部で用いたプログラム．波数基底の多極子を入力して相互作用バーテックスを既約分解する．作りが悪いので基底の数が増えるとすぐに重くなる(完全にテスト用)．動かすには<a href="http://gtpack.org" target="_blank">GTPack</a>が必要．'
        },
        {
          title: 'UPt3',
          type: 'Python',
          url: 'https://github.com/shuntarosumita/UPt3',
          text: '<a href="https://arxiv.org/abs/1801.03293" target="_blank">1801.03293</a>および<a href="https://arxiv.org/abs/1811.08627" target="_blank">1811.08627</a>の研究で使用したプログラム．UPt<sub>3</sub>のハミルトニアンの固有値を見たりChern数を計算したりする．'
        },
        {
          title: 'Sr2IrO4',
          type: 'C++',
          url: 'https://github.com/shuntarosumita/Sr2IrO4',
          text: '<a href="https://arxiv.org/abs/1702.08659" target="_blank">1702.08659</a>の研究で使用したプログラム．Sr<sub>2</sub>IrO<sub>4</sub>における−++−と−+−+の2つの磁気秩序と共存する超伝導状態の計算を行う．'
        },
        {
          title: '1d_zigzag',
          type: 'C++',
          url: 'https://github.com/shuntarosumita/1d_zigzag',
          text: '<a href="https://arxiv.org/abs/1603.09440" target="_blank">1603.09440</a>の研究で使用したプログラム．1次元ジグザグ格子において，磁気多極子と共存する超伝導状態を平均場近似の範囲で求めている．'
        }
      ] as ProgramInfo[]
    }
  }
})
